export default __webpack_public_path__ + "static/media/quiz.a4c9d7f7.jpeg";